import React, { useState } from "react";
import EmployeeHistoryRow from "./EmployeeHistoryRow";

export default function HistoryByEmployeeView({ data }) {
  const info = data.document_info;
  const employees = data.employees || [];
  const [expanded, setExpanded] = useState(new Set());

  const toggleAll = (open) =>
    open
      ? setExpanded(new Set(employees.map(e => e.employee_name)))
      : setExpanded(new Set());

  const toggleOne = (name) => {
    setExpanded(prev => {
      const n = new Set(prev);
      n.has(name) ? n.delete(name) : n.add(name);
      return n;
    });
  };

  return (
    <>
      <div className="p-3 bg-[#5a6db3] text-white font-semibold">
        Payroll Statement Details
      </div>

      <div className="grid grid-cols-2 gap-6 bg-white border rounded-b-lg p-4 shadow">
        <div>
          <h4 className="font-semibold mb-2">Company Information</h4>
          <p><b>Company:</b> {info.company_name}</p>
          <p><b>Currency:</b> {info.currency}</p>
          <p><b>Employees:</b> {info.total_employees}</p>
          <p><b>Frequency:</b> {info.pay_frequency}</p>
        </div>

        <div>
          <h4 className="font-semibold mb-2">Document Information</h4>
          <p><b>Filename:</b> {info.filename}</p>
          <p><b>Uploaded:</b> {info.upload_date}</p>
          <p><b>Status:</b> {info.processing_status}</p>
          <p><b>Method:</b> {info.extraction_method}</p>
        </div>
      </div>

      <div className="bg-white border shadow mt-6">
        {/* HEADER + ACTIONS */}
        <div className="flex justify-between items-center px-4 py-3 bg-[#5a6db3] text-white">
          <span className="font-semibold">
            History Report - By Employee ({employees.length})
          </span>

          <div className="flex gap-2">
            <button
              className="btn btn-sm btn-light"
              onClick={() => toggleAll(true)}
            >
              ▼ Expand All
            </button>

            <button
              className="btn btn-sm btn-light"
              onClick={() => toggleAll(false)}
            >
              ▶ Collapse All
            </button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full table-fixed text-sm">
            <thead className="bg-gray-100">
              <tr>
                <Th w={200}>Employee</Th>
                <Th w={120} align="center">Entries</Th>
                <Th w={160} align="right">Gross</Th>
                <Th w={120} align="right">Tax</Th>
                <Th w={160} align="right">Employee NICs</Th>
                <Th w={160} align="right">Employer NICs</Th>
                <Th w={160} align="right">Net Pay</Th>
                <Th w={90} align="center">View</Th>
              </tr>
            </thead>

            <tbody>
              {employees.map(emp => (
                <EmployeeHistoryRow
                  key={emp.employee_name}
                  employee={emp}
                  isOpen={expanded.has(emp.employee_name)}
                  onToggle={() => toggleOne(emp.employee_name)}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

/* =================== TABLE HEADER =================== */

const Th = ({ children, w, align = "left" }) => (
  <th
    style={{ minWidth: w }}
    className={`px-3 py-2 border text-${align}`}
  >
    {children}
  </th>
);
